import { takeRight } from 'lodash';

export default {
  getGeoChartData: (state) => {
    const { filter, chart_filters } = state;
    const data = [];

    if (filter) {
      switch (filter) {
        case 'states':
          data.push(['States', 'Sales Value']);
          state.stores.states.filter(item => item.country === chart_filters.country).forEach((item) => {
            data.push(
              [`${item.address}, ${item.country}`, item.revenue],
            );
          });
          break;
        case 'outlets':
          data.push(['Outlets', 'Sales Value']);
          state.stores[filter].filter(item => item.state === chart_filters.state).forEach((item) => {
            const name = item.address ? item.address : item.name;
            data.push(
              [`${name}, Nigeria`, item.revenue],
            );
          });
          break;
        default:
          data.push(['Countries', 'Sales Value']);
          state.stores[filter].forEach((item) => {
            const name = item.address ? item.address : item.name;
            data.push(
              [`${name}, Nigeria`, item.revenue],
            );
          });
      }
    }
    return data;
  },

  getRegion: (state) => {
    const { filter } = state;

    switch (filter) {
      case 'nations':
        return 'world';
      default:
        return 'NG';
    }
  },

  getLineChartData: (state) => {
    let { sales } = state;

    if (sales.length > 0) {
      if (sales.length > 10) {
        sales = takeRight(sales, 10);
      }

      let { line_chart_filters } = state;
      line_chart_filters = line_chart_filters.charAt(0).toUpperCase() + line_chart_filters.slice(1);

      const data = [['Sales', line_chart_filters]];

      sales.forEach((item) => {
        switch (line_chart_filters) {
          case 'Year':
            data.push([`${item.year}`, item.sales]);
            break;
          case 'Month':
            data.push([item.month, item.sales]);
            break;
          default:
            data.push([item.week, item.sales]);
            break;
        }
      });

      return data;
    }
    return [];
  },

  getStatesForTheSelectedNation: state => nation => state.stores.states.filter(item => item.country === nation),
  getOutletsForTheSelectedStates: state => region => state.stores.outlets.filter(item => item.state === region),
};
